<template>
    <div>
        <config-write-link v-for="component in optionLayouts" :key="`configComp${component}`" :writeLayout="component" :configData="configData" :setData="setData" :contentColumn = "contentColumn"></config-write-link>
    </div>
</template>

<script>
    import VuxAlert from '@/mixins/vux-alert';
    import configUtil from "@/components/config/configUtil";
    import ConfigWriteLink from "@/components/config/ConfigWriteLink";
    import ConfigValidator from "@/mixins/validators/ConfigValidator"
    import EventBus from "@/utils/event-bus";
    import util from "@/mixins/util";

    export default {
        name: 'ConfigWriteComponent',
        components: {
            ConfigWriteLink
        },
        mixins: [ VuxAlert, configUtil, ConfigValidator ],
        props: {
            configType: {
                type: String,
                default: '',
            },
            configKey: {
                default: null,
            },
        },
        data() {
            return{
                optionLayouts: [],
                createApiParamSet: {},
                detailApiParamSet: {},
                directUrl: '',
                subFunc : '',
                resultAlertTxt: '',
                validateAlertText: '',
                parsingData: {},
                configData: {},
                contentColumn : ''
            }
        },
        mounted() {
        },
        watch: {

        },
        created() {
            this.initConfig();
            EventBus.$on('writeConfig', this.writeConfig);
        },
        beforeDestroy() {
            EventBus.$off('writeConfig');
        },
        methods: {
            initConfig() {
                let conConfig = this.returnConConfig(this.configType)
                this.createApiParamSet = conConfig.createApiParamSet;
                this.detailApiParamSet = conConfig.detailApiParamSet;
                this.subFunc = conConfig.subFunc;
                this.directUrl = conConfig.directUrl;
                this.resultAlertTxt = conConfig.resultAlertTxt;
                this.contentColumn = conConfig.parsingData.content;
                this.validateAlertText = conConfig.validateAlertText;
                this.parsingData = conConfig.parsingData;
                if(this.configKey != null) {
                    this.getInfo();
                }else{
                    this.initTemplate();
                }
            },
            initTemplate() {
                let conConfig = this.returnConConfig(this.configType)
                this.optionLayouts = conConfig.optionLayouts;
            },
            setData(key, value) {
                this[key] = value;
            },
            getInfo() {
                let params = JSON.parse(JSON.stringify(this.detailApiParamSet));
                params.id = this.configKey;
                try {
                    this.$api.$config.getConfig(params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type != 1) {
                            this.createAlert({
                                title: '알림',
                                content: '약관정보를 불러올 수 없습니다.',
                                btnText: '확인',
                                hide: () => {
                                    this.$router.back();
                                }
                            })
                        }
                        let info = res.List[0];
                        //메모도 들어가야함
                        this.configData = info;
                        this.initTemplate();
                    });
                }catch (e) {
                    console.log(e);
                }
            },
            writeConfig() {
                let validateArr = Object.keys(this.parsingData);
                console.log(validateArr);
                this.$validate(validateArr).then((success) => {
                    if(!success) {
                        this.errorAlert(this.validateAlertText);
                        return false;
                    }
                    let params = JSON.parse(JSON.stringify(this.createApiParamSet));
                    let dataKeys = Object.keys(this.parsingData);
                    dataKeys.forEach(dataKey => {
                        params[this.parsingData[dataKey]] = this[dataKey];
                    });
                    if(this.configKey){
                        delete params.c_idx;
                        params.cs_idx = this.configKey; //키
                    }

                    try {
                        this.$api.$config[this.subFunc](params).then(res => res.Data.Result).then(res => {
                            let type = this.writeReturnType(res.Info.type);
                            if(type != true) {
                                this.errorAlert(type);
                                return false;
                            }
                            this.createAlert({
                                title: '확인',
                                content: this.resultAlertTxt,
                                btnText: '확인',
                                hide: () => {
                                    if(this.directUrl === '') {
                                        return false;
                                    }
                                    if(this.directUrl === 'back') {
                                        this.$router.back();
                                        return false;
                                    }
                                    let url = this.directUrl;
                                    if(this.directType === 'detail') {
                                        url = url+res.List;
                                    }
                                    this.$router.push(url);
                                }
                            })
                        })
                    }catch (e) {
                        console.log(e);
                    }
                })
            },
            writeReturnType(type) {
                let typeNum = Number(type);
                switch (typeNum) {
                    case 1:
                        return true;
                    case -6:
                        return '나라 중복입니다.';
                    default:
                        return '약관 수정에 실패하였습니다. 잠시 다시 시도해 주세요.';
                }
            },
        }
    }
</script>
